import { createSdk } from "@hyper-fetch/core";
import { createSocketSdk } from "@hyper-fetch/sockets";

import { client, socket } from "./client";
import { notificationsConfiguration } from "./notifications/notifications.configuration";
import { userConfiguration } from "./user/user.configuration";
import type { ApiRoutesSdk, WsSocketSdk } from "@complete-athlete/backend";

export const sdk = createSdk<typeof client, ApiRoutesSdk>(client)
  .$configure(userConfiguration)
  .$configure(notificationsConfiguration);

export const socketSdk = createSocketSdk<typeof socket, WsSocketSdk>(socket);
